import { render } from "./TestItemPage.vue?vue&type=template&id=cbdd3a8c"
import script from "./TestItemPage.vue?vue&type=script&lang=js"
export * from "./TestItemPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductManage/ConfigManagement/components/Battery/TestItemPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cbdd3a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cbdd3a8c', __exports__)) {
    api.reload('cbdd3a8c', __exports__)
  }
  
  module.hot.accept("./TestItemPage.vue?vue&type=template&id=cbdd3a8c", () => {
    api.rerender('cbdd3a8c', render)
  })

}


export default __exports__